import { Excalidraw, WelcomeScreen, Footer, MainMenu, TTDDialog, TTDDialogTrigger} from "@excalidraw/excalidraw";
import { defaultLang, languages, useI18n } from "@excalidraw/excalidraw";
import { useState, useEffect, Fragment} from "react";
import { serializeAsJSON, exportToSvg, exportToBlob, loadLibraryFromBlob} from "@excalidraw/excalidraw";
import axios from "axios";
import { MultiSelect } from "react-multi-select-component";
import Select, {components} from "react-select";
import './App.css'
import libOptions from "./LibOptions";
import styled from "styled-components";
import {useRef} from "react";

// const libPrefix = "https://libraries.excalidraw.com/libraries"
const libExtension ="excalidrawlib"
// initial data: dockered sidebar, no elements
const initialData = {
    appState: {
        defaultSidebarDockedPreference: true,
        isSidebarDocked: true,
    },
    scrollToContent: true
}

const UIOptions = {
    canvasActions: {
        toggleTheme: true
    },
};

const queryParameters = new URLSearchParams(window.location.search);
const libBaseUrl = queryParameters.get('libUrl');
const userLang = queryParameters.get('lang');

const theme = {
    blue: {
        bg: "#0d6efd",
        hover: "#0b5ed7"
    },
    grey: {
        bg: "#6c757d",
        hover: "#5c636a"
    }
};

const Button = styled.button`
  display: "flex";
  background-color: ${(props) => theme[props.theme].bg};
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  outline: 0;
  margin: 0px 0px;
  border: 0px;
  cursor: pointer;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

const PublishButton = ({ excalidrawAPI }) => {
    const [disabled, setDisabled] = useState(false);
    const publishHandler = async (event) => {
        setDisabled(true);
        // console.log("React App ----> publishHandler");

        if (!excalidrawAPI) {
            return
        }

        // get elements && appState && files  from excalidrawAPI
        const elements = excalidrawAPI.getSceneElements();
        if (!elements || !elements.length) {
            return
        }
        const appState = excalidrawAPI.getAppState();
        const files = excalidrawAPI.getFiles();

        // generate drawData, svg file, png file
        const drawData = serializeAsJSON(elements, excalidrawAPI.getAppState(), files, "local");
        // console.log('React App ----> drawData:', drawData);
        const svgData = await exportToSvg({elements, appState, files });
        //console.log('React App ----> svgData:', svgData);
        const pngBlob = await exportToBlob({
            elements: elements,
            appState: appState,
            files: files,
            maxWidthOrHeight: 1000,
            mimeType: 'image/png',
        });

        // get width and height of
        const width = svgData.getAttribute('width');
        const height = svgData.getAttribute('height');
        //console.log('React App ----> width and height:', width, height);

        // post message "PUBLISH" to parent window
        window.parent.postMessage({
            type: 'PUBLISH',
            data: {
                drawData: drawData,
                svgData: svgData.outerHTML,
                svgRect: {
                    width: width,
                    height: height
                },
                pngBlob: pngBlob
            }
        }, '*');


    };

    const { t } = useI18n();
    return (
        <Button theme="blue" disabled={disabled} onClick={publishHandler}>
            {t("buttons.submit")}
        </Button>
    )
}

const CancelButton = () => {
    const { t } = useI18n();
    return (
        <Button
            theme="grey"
            onClick={() => {
                window.parent.postMessage({type: 'CANCEL'}, '*');
            }}
        >
            {t("buttons.cancel")}
        </Button>
    )
}

const DebugButton = ({excalidrawAPI}) => {
    return (
        <Button theme="blue" disabled={false} onClick={  () => {
            console.log("App state----> :", excalidrawAPI.getAppState());
            excalidrawAPI.toggleMenu("customSidebar");
        }}>
            Debug
        </Button>
    )
}

const LibrarySelectorAnother = ({ excalidrawAPI, libBaseUrl }) => {
    const [selectedLibs, setSelectedLibs] = useState([]);

    useEffect( () => {
        //console.log("React App ----> selectedLibs:", selectedLibs);
        if (!excalidrawAPI) {
            return;
        }

        let libs = []
        if (selectedLibs && selectedLibs.length !== 0) {
            libs = selectedLibs.map( lib => lib.value);
        }
        //console.log("React App ----> selected libs:", libs)
        updateLibraries(excalidrawAPI, libBaseUrl, libs);
    }, [selectedLibs]);

    return (
        <MultiSelect
            options={libOptions}
            value={selectedLibs}
            onChange={setSelectedLibs}
            labelledBy="Select"
        />
    );
}

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const ValueContainer = ({ children, ...props }) => {
    const { getValue } = props;
    const selectedOptions = getValue();
    const maxOptions = 3;
    return (
        <components.ValueContainer {...props}>
            {children}
            <div style={{ display: "inline-block", marginLeft: "auto" }}>
                {selectedOptions.length}/{maxOptions}
            </div>
        </components.ValueContainer>
    );
};

const Spacer = () => {
    return(<div style={{flexGrow: "1"}}></div>)
}

const libSelectorStyle = {

    minWidth: "300px",
}

const indicatorStyle = {
    margin: "0 auto",
    marginInlineStart: "0.6em",
    alignItems: "center",
    display: "flex",
    color: "#ff8c00",
    fontWeight: "bold",
    flexGrow: "0",
}

const customStyles = {
    container: base => ({
        ...base,
        display: "flex",
        minWidth: "300px",
        // marginInlineStart: "0.6em",
        margin: "0 auto",
    }),

    control: base => ({
        ...base,
        display: "flex",
        minWidth: "300px",
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        display: "flex",
    }),

    placeholder: base => ({
        ...base,
        fontStyle: 'italic',
        display: "flex",
    })
};

const LibrarySelector = ({ excalidrawAPI, libBaseUrl }) => {
    const [selectedLibs, setSelectedLibs] = useState([]);
    const libsRef = useRef({});

    const updateLibraries = async (excalidrawAPI, libBaseUrl, libraries=[]) => {

        const updateLibs = async ( isClear=false) => {
            //console.log("isClear:", isClear);

            let merge, libs
            if (isClear) {
                merge = false;
                libs = ["null"];
                //console.log("React App ----> clear libraries")
            } else {
                merge = true;
                libs = libraries;
                //console.log("React App ----> update libraries:", libs)
            }

            for (const lib of libs) {

                let libraryItems;

                if (!libsRef.current.hasOwnProperty(lib)) {
                    // if libsRef does not have the lib, then download it
                    const resp = await axios({
                        url: `${libBaseUrl}/${lib}.${libExtension}`,
                        method: 'GET',
                        responseType: 'blob',
                    });
                    libraryItems = await loadLibraryFromBlob(resp.data);
                    // save the lib to libsRef
                    libsRef.current[lib] = libraryItems
                } else {
                    // if libsRef has the lib, then use it
                    libraryItems = libsRef.current[lib];
                }

                await excalidrawAPI.updateLibrary({
                    libraryItems,
                    merge: merge,
                    openLibraryMenu: true,
                    defaultStatus: "published"});
                // console.log("all libsRef:", libsRef.current);
            }
        }

        // clear libs first
        await updateLibs(true);

        // then update the with selected libs
        if (libraries.length === 0) {
            return;
        } else {
            await updateLibs(false);
        }
    }

    useEffect( () => {
        //console.log("React App ----> selectedLibs:", selectedLibs);
        if (!excalidrawAPI) {
            return;
        }

        let libs = []
        if (selectedLibs && selectedLibs.length !== 0) {
            libs = selectedLibs.map( lib => lib.value);
        }
        //console.log("React App ----> selected libs:", libs)
        updateLibraries(excalidrawAPI, libBaseUrl, libs);
    }, [selectedLibs]);

    return (
        <Select
            isMulti
            menuPlacement="top"
            options={libOptions}
            components={{
                Option: Option,
                ValueContainer: ValueContainer
            }}
            isOptionDisabled={(option) =>
                !selectedLibs.includes(option) && selectedLibs.length >= 3
            } // limited the max select options for performance reason
            value={selectedLibs}
            onChange={setSelectedLibs}
            allowSelectAll={false}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            className="react-basic-multi-select"
            classNamePrefix="react-select"
            styles={customStyles}
            placeholder={"Add libraries"}
            maxMenuHeight={500}
        />
    );
}



function App() {
    // const queryParameters = new URLSearchParams(window.location.search)
    // const pageId = queryParameters.get('pageId')

    const [excalidrawAPI, setExcalidrawAPI] = useState(null);
    const { t } = useI18n();

    useEffect(() => {
        //console.log("React App ----> excalidrawAPI:", excalidrawAPI);
        if(!excalidrawAPI) return;

        const handler = (event) => {
            // console.log('React App ----> received event from react:', event.data.type, event);
            if (event.data.type === 'LOAD') {
                // console.log('React App ----> to update scene with data from parent window');
                const rawData = event.data.data;
                const files = rawData.files;
                // console.log("---> files: ", files);
                excalidrawAPI.updateScene(rawData);
                if (files) {
                    const fileDataList= Object.values(files)
                    fileDataList.length > 0 && excalidrawAPI.addFiles(fileDataList);
                }
            }
        }

        window.addEventListener("message", handler);
        return () => {
            window.removeEventListener("message", handler);
        };
    }, [excalidrawAPI]);

    useEffect(() => {
        // post message "INIT" to parent window, only run once
        //console.log ('React App ----> post message "INIT" to parent window');
        window.parent.postMessage({type: 'INIT'}, '*');
    }, []);

    //console.log('React App ----> to render react app');

    return (
      <>
        <div style={{ height: "100vh"}}>
          <Excalidraw
              initialData={initialData}
              UIOptions={UIOptions}
              excalidrawAPI={(api)=> setExcalidrawAPI(api)}
              langCode={userLang}
              renderTopRightUI={() => {
                  return(<Fragment>
                      <PublishButton excalidrawAPI={excalidrawAPI}/>
                      <CancelButton/>
                      {/*<DebugButton excalidrawAPI={excalidrawAPI}/>*/}
                  </Fragment>)
              }}
          >
              <MainMenu>
                  <MainMenu.DefaultItems.LoadScene />
                  <MainMenu.DefaultItems.SaveToActiveFile />
                  <MainMenu.DefaultItems.Export />
                  <MainMenu.DefaultItems.SaveAsImage />

                  <MainMenu.Separator />

                  <MainMenu.DefaultItems.ClearCanvas />

                  <MainMenu.Separator />

                  <MainMenu.DefaultItems.ToggleTheme />
                  <MainMenu.DefaultItems.ChangeCanvasBackground />
              </MainMenu>


              <WelcomeScreen/>
              <Footer>
                  <Spacer/>
                  <LibrarySelector
                      excalidrawAPI={excalidrawAPI}
                      libBaseUrl={libBaseUrl}
                  />
                  <p style={indicatorStyle}> &#x1F448; Add Libraries &#128640;</p>
                  <Spacer/>
              </Footer>

              <TTDDialog
                  onTextSubmit={async (input) => {
                      try {
                          const response = await fetch(
                              'https://ai.xdevpod.com/gmc',
                              {
                                  method: "POST",
                                  headers: {
                                      Accept: "application/json",
                                      "Content-Type": "application/json",
                                  },
                                  body: JSON.stringify({ prompt: input }),
                              },
                          );

                          const rateLimit = response.headers.has("X-Ratelimit-Limit")
                              ? parseInt(response.headers.get("X-Ratelimit-Limit") || "0", 10)
                              : undefined;

                          const rateLimitRemaining = response.headers.has(
                              "X-Ratelimit-Remaining",
                          )
                              ? parseInt(
                                  response.headers.get("X-Ratelimit-Remaining") || "0",
                                  10,
                              )
                              : undefined;

                          const json = await response.json();

                          if (!response.ok) {
                              if (response.status === 429) {
                                  return {
                                      rateLimit,
                                      rateLimitRemaining,
                                      error: new Error(
                                          "Too many requests today, please try again tomorrow!",
                                      ),
                                  };
                              }

                              throw new Error(json.message || "Generation failed...");
                          }

                          const generatedResponse = json.code;
                          if (!generatedResponse) {
                              throw new Error("Generation failed...");
                          }

                          console.log("Generated response", generatedResponse);

                          return { generatedResponse, rateLimit, rateLimitRemaining };
                      } catch (err) {
                          throw new Error("Request failed");
                      }
                  }}
              />
              <TTDDialogTrigger />
          </Excalidraw>
        </div>
      </>
    );
}

export {App}


